import React, { useState, useEffect } from 'react'
import { Row, Col, List, Checkbox, Spin, message as alert } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { getProducts } from '../../redux/slices/productsSlice'
import { getClientProductPermissions, createClientProductPermission, deleteClientProductPermission } from '../../redux/slices/permissionsSlice'

const ProductPermissions = ({ clientId }) => {
    const dispatch = useDispatch()
    const { products: allProducts } = useSelector(state => state.products)
    const { permissions, isLoading: permissionsLoading } = useSelector(state => state.permissions)
    const { isLoading: productsLoading } = useSelector(state => state.products)
    
    const [checkedProducts, setCheckedProducts] = useState([])

    useEffect(() => {
        if (clientId) {
            dispatch(getProducts())
            dispatch(getClientProductPermissions({ clientId }))
        }
    }, [dispatch, clientId])

    useEffect(() => {
        // As permissões retornam os produtos que o cliente TEM acesso
        // Extraímos os IDs desses produtos para marcar como checked
        if (permissions && permissions.length > 0) {
            const productIds = permissions.map(p => {
                // A API retorna os produtos diretamente no array de permissões
                return p.id || p.productId || (p.product && p.product.id)
            }).filter(Boolean)
            setCheckedProducts(productIds)
        } else {
            setCheckedProducts([])
        }
    }, [permissions])

    const handleToggle = async (productId, checked) => {
        try {
            if (checked) {
                await dispatch(createClientProductPermission({
                    clientId,
                    productId
                })).unwrap()
                // Atualizar estado local imediatamente
                setCheckedProducts(prev => [...prev, productId])
                alert.success('Permissão adicionada com sucesso!')
            } else {
                await dispatch(deleteClientProductPermission({
                    clientId,
                    productId
                })).unwrap()
                // Atualizar estado local imediatamente removendo o produto
                setCheckedProducts(prev => prev.filter(id => id !== productId))
                alert.success('Permissão removida com sucesso!')
            }
            // Recarregar permissões para sincronizar com o backend
            dispatch(getClientProductPermissions({ clientId }))
        } catch (error) {
            alert.error(error || 'Erro ao atualizar permissão')
            // Em caso de erro, recarregar permissões para reverter estado
            dispatch(getClientProductPermissions({ clientId }))
        }
    }

    // Mostrar TODOS os produtos disponíveis
    // Se não houver produtos carregados de getProducts, usar os produtos das permissões como fallback
    // As permissões contêm os produtos que o cliente JÁ TEM acesso
    const productsToShow = (allProducts && allProducts.length > 0) ? allProducts : (permissions && permissions.length > 0 ? permissions : [])

    if (productsLoading || permissionsLoading) {
        return <Spin />
    }

    return (
        <Row className="mt-25" id="produtos-disponiveis">
            <Col md={4}>
                <label className="tx-placeholder font-bold">Produtos Disponíveis</label>
            </Col>
            <Col md={20} className="d-flex flex-column justify-center">
                <hr className="profile-divisor" />
                <div className="mt-15 pl-20">
                    {productsToShow && productsToShow.length > 0 ? (
                        <List
                            dataSource={productsToShow}
                            renderItem={(product) => {
                                const productId = product.id || product.productId
                                const isChecked = checkedProducts.includes(productId)
                                const productName = product.title || product.nome || 'Produto sem nome'
                                const productType = product.product_type?.label || product.type_of_product || product.tipo || ''
                                const productStatus = product.product_status?.label || product.status || ''
                                
                                return (
                                    <List.Item>
                                        <Checkbox
                                            checked={isChecked}
                                            onChange={(e) => handleToggle(productId, e.target.checked)}
                                        >
                                            <div style={{ marginLeft: 8 }}>
                                                <div className="tx-pink font-bold">{productName}</div>
                                                <div className="tx-gray">
                                                    {productType && `Tipo: ${productType}`}
                                                    {productStatus && ` | Status: ${productStatus}`}
                                                </div>
                                            </div>
                                        </Checkbox>
                                    </List.Item>
                                )
                            }}
                        />
                    ) : (
                        <p className="tx-gray">Nenhum produto disponível</p>
                    )}
                </div>
            </Col>
        </Row>
    )
}

export default ProductPermissions
